import {
  Transforms,
  Node,
  Path,
  Editor,
  Range
} from 'slate';

import elementTypes from '../../elements/types';
import HelptapEditor from '../../helpers';

/**
 * 
 * This does the following
 * 1. Deletes TOGGLE_LIST_ITEM, if it does not have HEAD & BODY nodes in its 0 & 1st children positions or if it has anything else
 * 2. Deletes TOGGLE_LIST_HEAD, if it's parent is not a TOGGLE_LIST_ITEM
 * 3. Deletes TOGGLE_LIST_BODY, if it's parent is not a TOGGLE_LIST_ITEM
 * 
 * 
 * */
function withSchema(editor) {

  const { normalizeNode, deleteBackward } = editor;

  editor.normalizeNode = entry => {
    const [node, path] = entry;

    // Rule for 'columns' node: Only allow 'column' children
    if (node.type === elementTypes.TOGGLE_LIST_ITEM) {

      if (node.children.length !== 2) {
        Transforms.removeNodes(editor, { at: path });
        return;
      }

      const headNode = Node.get(node, [0]);

      if (headNode.type !== elementTypes.TOGGLE_LIST_HEAD) {
        Transforms.removeNodes(editor, { at: path });
        return;
      }

      const bodyNode = Node.get(node, [1]);

      if (bodyNode.type !== elementTypes.TOGGLE_LIST_BODY) {
        Transforms.removeNodes(editor, { at: path });
        return;
      }

    }

    if (node.type === elementTypes.TOGGLE_LIST_HEAD) {

      const parentPath = Path.parent(path);
      const toggleNode = Node.get(editor, parentPath);

      if (toggleNode.type !== elementTypes.TOGGLE_LIST_ITEM) {
        Transforms.removeNodes(editor, { at: path });
        return;
      }

    }

    if (node.type === elementTypes.TOGGLE_LIST_BODY) {

      const parentPath = Path.parent(path);
      const toggleNode = Node.get(editor, parentPath);

      if (toggleNode.type !== elementTypes.TOGGLE_LIST_ITEM) {
        Transforms.removeNodes(editor, { at: path });
        return;
      }

    }

    normalizeNode(entry);

  };

  editor.deleteBackward = () => {

    const { selection } = editor;

    if (selection && Range.isCollapsed(selection)) {

      const [headMatch] = Editor.nodes(editor, {
        match(node) {
          return node.type === elementTypes.TOGGLE_LIST_HEAD;
        },
        mode: 'lowest'
      });

      if (headMatch) {
        const [node, nodePath] = headMatch;
        const containerPath = Path.parent(nodePath);
        const container = Node.get(editor, containerPath);
        if (Node.string(node) === '') {
          Editor.withoutNormalizing(editor, () => {
            Transforms.removeNodes(editor, { at: containerPath });
            HelptapEditor.paragraph.insert(editor, containerPath);
            // if container has some content, lets append that
            if (Node.string(container) !== '') {
              const childPath = Path.next(containerPath);
              for (let index = container.children[1].children.length - 1; index >= 0; index--) {
                const child = container.children[1].children[index];
                Transforms.insertNodes(editor, child, { at: childPath });
              }
            }
            Transforms.select(editor, containerPath);
          });
          return;
        }

      }

      const [bodyMatch] = Editor.nodes(editor, {
        match(node) {
          return node.type === elementTypes.TOGGLE_LIST_BODY;
        },
        mode: 'lowest'
      });

      if (bodyMatch) {}

    }

    deleteBackward();
  };

  return editor;

};

export default withSchema;